import { useEffect, useState } from "react";
import SEOHead from "@/components/SEOHead";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import MobilHero from "@/components/mobil/MobilHero";
import MobilIntro from "@/components/mobil/MobilIntro";
import MobilServices from "@/components/mobil/MobilServices";
import MobilGallery from "@/components/mobil/MobilGallery";
import MobilProcess from "@/components/mobil/MobilProcess";
import MobilCalendar from "@/components/mobil/MobilCalendar";
import MobilContact from "@/components/mobil/MobilContact";
import { api } from "@/lib/api";
import { useMobilI18n } from "@/lib/mobilI18n";

const setMeta = (selector, content) => document.head.querySelector(selector)?.setAttribute("content", content);

function useMobilSeo(m) {
  useEffect(() => {
    document.title = m.seo.title;
    setMeta('meta[name="title"]', m.seo.title);
    setMeta('meta[name="description"]', m.seo.description);
    setMeta('meta[property="og:title"]', m.seo.title);
    setMeta('meta[property="og:description"]', m.seo.description);
    setMeta('meta[property="og:url"]', "https://aurasantcugat.es/eventos-externos");
    const canonical = document.head.querySelector('link[rel="canonical"]');
    canonical?.setAttribute("href", "https://aurasantcugat.es/eventos-externos");
    return () => canonical?.setAttribute("href", "https://aurasantcugat.es/");
  }, [m]);
}

export default function AuraMobilPage() {
  const { m } = useMobilI18n();
  const [config, setConfig] = useState({ whatsapp_number: "34638382033" });
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash.length > 1) setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 400);
    else window.scrollTo(0, 0);
    api.get("/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  useMobilSeo(m);

  const links = [
    { id: "que-es", label: m.nav.intro },
    { id: "serveis", label: m.nav.services },
    { id: "galeria-externs", label: m.nav.gallery },
    { id: "proces", label: m.nav.process },
    { id: "disponibilitat-externs", label: m.nav.calendar },
    { id: "contacte-externs", label: m.nav.contact },
  ];

  return (
    <div className="min-h-screen bg-[#fdfcf9] text-[#2A2421]" data-testid="aura-mobil-page">
      <SEOHead />
      <Navbar
        links={links}
        featured={{ to: "/", label: m.nav.backToSala }}
        cta={{ href: "#contacte-externs", label: m.nav.cta }}
        logoHref="/"
      />
      <MobilHero />
      <MobilIntro />
      <MobilServices />
      <MobilGallery />
      <MobilProcess />
      <MobilCalendar whatsappNumber={config.whatsapp_number} refreshKey={refreshKey} />
      <MobilContact whatsappNumber={config.whatsapp_number} onSubmitted={() => setRefreshKey((n) => n + 1)} />
      <Footer linkBase="/" />
      <WhatsAppFloat number={config.whatsapp_number} />
    </div>
  );
}
